import {fabric} from "fabric";

export function initCircle (x = null, y = null)
{
    let params = {};
    if (x !== null && y !== null)
    {
        params = {top : y, left : x, radius: 0};
    }
    else
    {
        params = {top : 100, left : 100, radius: 100};
    }

    return new fabric.Circle({
        ...params,
        strokeWidth : 3,
        opacity: 1,
        stroke : '#eaff00',
        fill : 'transparent',
        strokeUniform : true,
        noScaleCache: false
    });
}
